import { Select as AntSelect } from "antd"
import type { ReactNode } from "react"
import type { DefaultOptionType } from "antd/es/select"
import type { Variant } from "antd/es/config-provider"
import type { SelectProps } from "antd"

type Props = {
	variant: Variant
	options: DefaultOptionType[]
	placement?: SelectProps["placement"]
	value?: string | number | null
	open?: boolean
	placeholder?: string
	className?: string
	allowClear?: boolean
	disabled?: boolean
	onChange?: (e: string | number) => void
	onOpenChange?: (arg: boolean) => void
	showSearch?: boolean
	optionFilterProp?: SelectProps["optionFilterProp"]
	renderInPlace?: boolean
	suffixIcon?: ReactNode
}

export const Select = ({
	variant,
	options,
	placement = "bottomRight",
	value,
	placeholder,
	className,
	allowClear = false,
	disabled = false,
	onChange,
	onOpenChange,
	showSearch = false,
	optionFilterProp,
	renderInPlace = false,
	suffixIcon,
}: Props) => {
	return (
		<div data-testid="select">
			<AntSelect
				style={{ width: "100%" }}
				disabled={disabled}
				placeholder={placeholder}
				allowClear={allowClear}
				variant={variant}
				options={options}
				placement={placement}
				value={value}
				onChange={onChange}
				onOpenChange={onOpenChange}
				className={className}
				showSearch={showSearch}
				optionFilterProp={optionFilterProp}
				suffixIcon={suffixIcon}
				getPopupContainer={renderInPlace ? (trigger) => trigger.parentElement! : undefined}
			/>
		</div>
	)
}
